<div class="card" *transloco="let t">
    <div class="card-header">
        <b>{{ t('Monitor Access Controls') }}</b>
    </div>
    <div class="card-body">

        @if(has_access){

        <form class="info-form" [formGroup]="accessFormGroup" cForm (ngSubmit)="submitAccessControls()">
            <div class="row">
                <div class="col">
                    <div class="row">
                        {{ t('Workers') }}
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <ng-select
                            id="worker_access" name="worker_access"
                            placeholder="{{ t('Access Level') }}"
                            formControlName="worker_access"
                            [items]="access_levels_worker">
                            </ng-select>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="worker_index" name="worker_index" formControlName="worker_index">
                            <label class="form-check-label" for="worker_index">
                                &nbsp; &nbsp;{{ t('View All Workers') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="worker_view" name="worker_view" formControlName="worker_view">
                            <label class="form-check-label" for="worker_view">
                                &nbsp; &nbsp;{{ t('View Single Worker') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="worker_create" name="worker_create" formControlName="worker_create">
                            <label class="form-check-label" for="worker_create">
                                &nbsp; &nbsp;{{ t('Add a Worker') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="worker_update" name="worker_update" formControlName="worker_update">
                            <label class="form-check-label" for="worker_update">
                                &nbsp; &nbsp;{{ t('Edit a Worker') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="worker_delete" name="worker_delete" formControlName="worker_delete">
                            <label class="form-check-label" for="worker_delete">
                                &nbsp; &nbsp;{{ t('Delete a Worker') }}
                            </label>
                        </div>
                    </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                    <div class="row">
                        {{ t('Monitors') }}
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <ng-select
                            id="monitor_access" name="monitor_access"
                            placeholder="{{ t('Access Level') }}"
                            formControlName="monitor_access"                            
                            [items]="access_levels">
                            </ng-select>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="monitor_index" name="monitor_index" formControlName="monitor_index">
                            <label class="form-check-label" for="monitor_index">
                                &nbsp; &nbsp;{{ t('View All Monitors') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="monitor_view" name="monitor_view" formControlName="monitor_view">
                            <label class="form-check-label" for="monitor_view">
                                &nbsp; &nbsp;{{ t('View Single Monitor') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="monitor_create" name="monitor_create" formControlName="monitor_create">
                            <label class="form-check-label" for="monitor_create">
                                &nbsp; &nbsp;{{ t('Add a Monitor') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="monitor_update" name="monitor_update" formControlName="monitor_update">
                            <label class="form-check-label" for="monitor_update">
                                &nbsp; &nbsp;{{ t('Edit a Monitor') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="monitor_delete" name="monitor_delete" formControlName="monitor_delete">
                            <label class="form-check-label" for="monitor_delete">
                                &nbsp; &nbsp;{{ t('Delete a Monitor') }}
                            </label>
                        </div>
                    </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col">
                    <div class="row">
                        {{ t('Groups') }}
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <ng-select
                            id="group_access" name="group_access"
                            placeholder="{{ t('Access Level') }}"
                            formControlName="group_access"                            
                            [items]="access_levels">
                            </ng-select>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="group_index" name="group_index" formControlName="group_index">
                            <label class="form-check-label" for="group_index">
                                &nbsp; &nbsp;{{ t('View All Groups') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="group_view" name="group_view" formControlName="group_view">
                            <label class="form-check-label" for="group_view">
                                &nbsp; &nbsp;{{ t('View Single Group') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="group_create" name="group_create" formControlName="group_create">
                            <label class="form-check-label" for="group_create">
                                &nbsp; &nbsp;{{ t('Add a Group') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="group_update" name="group_update" formControlName="group_update">
                            <label class="form-check-label" for="group_update">
                                &nbsp; &nbsp;{{ t('Edit a Group') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="group_delete" name="group_delete" formControlName="group_delete">
                            <label class="form-check-label" for="group_delete">
                                &nbsp; &nbsp;{{ t('Delete a Group') }}
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <ng-select 
                            [items]="okService.groups"
                            bindLabel="name"
                            bindValue="id"
                            [multiple]="true"
                            placeholder="{{ t('Groups') }}"
                            formControlName="group_ids">
                            </ng-select>
                        </div>
                    </div>
                </div>
              </div>
              <div class="row mb-2" *ngIf="okService.hasFeature('team_broadcast')">
                <div class="col">
                    <div class="row">
                        {{ t('Team Broadcast') }}
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <ng-select
                            id="broadcast_access" name="broadcast_access"
                            placeholder="{{ t('Access Level') }}"
                            formControlName="broadcast_access"
                            [items]="access_levels_broadcast">
                            </ng-select>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="broadcast_index" name="broadcast_index" formControlName="broadcast_index">
                            <label class="form-check-label" for="broadcast_index">
                                &nbsp; &nbsp;{{ t('View All Broadcasts') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="broadcast_view" name="broadcast_view" formControlName="broadcast_view">
                            <label class="form-check-label" for="broadcast_view">
                                &nbsp; &nbsp;{{ t('View Single Broadcast') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="broadcast_create" name="broadcast_create" formControlName="broadcast_create">
                            <label class="form-check-label" for="broadcast_create">
                                &nbsp; &nbsp;{{ t('Send a Broadcast') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="broadcast_update" name="broadcast_update" formControlName="broadcast_update">
                            <label class="form-check-label" for="broadcast_update">
                                &nbsp; &nbsp;{{ t('Edit a Draft') }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input class="form-check-input" type="checkbox" id="broadcast_delete" name="broadcast_delete" formControlName="broadcast_delete">
                            <label class="form-check-label" for="broadcast_delete">
                                &nbsp; &nbsp;{{ t('Delete a Draft') }}
                            </label>
                        </div>
                    </div>
                </div>
              </div>
              <div class="row">
                <div class="col text-center">
                    
                    <button  class="btn btn-outline-primary" type="submit">
                        <i class="fa-solid fa-check"></i> {{ t('Update Monitor Access') }}
                    </button>
                </div>
                <div class="col text-center">
                    <button  class="btn btn-outline-danger" (click)="removeMonitorAccess()">
                        <i class="fa-solid fa-times"></i> {{ t('Remove Monitor Access') }}
                    </button>
                </div>

              </div>
        </form>

    }
    @else{
        <button cButton class="px-4 text-white btn-success" (click)="createMonitorAccess()">
            <i class="fa-solid fa-check"></i> {{ t('Create Custom Monitor Access') }}
        </button>
    }
    </div>
</div>